import React from 'react';

import { Formik, Field } from 'formik';

import { DepartmentSelector, VenueSelector } from '../Selectors';

import TableFilterModal from 'CommonComponents/TableFilterModal';

import useSourceOptions from 'Hooks/useSourceOptions';

const PRIORITIES = ['R', 'A', 'G'];

export default function GeneralRisksFilters(props) {
    const sourceOptions = useSourceOptions(props.datasets?.venuesOptions);

    return (
        <TableFilterModal modalBodyClassNames="tw-w-128" noActions>
            <Formik
                enableReinitialize
                initialValues={{
                    owner: '',
                    type_id: '',
                    impact_category_id: '',
                    priority: '',
                    source_ids: [],
                    budget_department_key: '',
                }}
                onSubmit={(values, actions) => {
                    props
                        .onSubmit(values)
                        .catch((e) => {
                            console.error(e);
                        })
                        .finally(() => {
                            actions.setSubmitting(false);
                        });
                }}
                onReset={() => props.onReset()}
            >
                {({ values, isSubmitting, setFieldValue, handleSubmit, handleReset }) => (
                    <div>
                        <div className="tw-flex tw-flex-col tw-gap-2">
                            <Field type="text" className="text-input" name="owner" placeholder={$t('Owner')} />
                            <label className="tw-flex tw-flex-col">
                                <div className="select-label">{$t('Type')}:</div>
                                <Field as="select" className="select-input" name="type_id">
                                    <option value="">{$t('Type')}</option>
                                    {props.datasets?.types?.map(({ id, title }) => (
                                        <option key={id} value={id}>
                                            {title}
                                        </option>
                                    ))}
                                </Field>
                            </label>
                            <label className="tw-flex tw-flex-col">
                                <div className="select-label">{$t('Impact category')}:</div>
                                <Field as="select" className="select-input" name="impact_category_id">
                                    <option value="">{$t('Impact category')}</option>
                                    {props.datasets?.impactCategories?.map(({ id, title }) => (
                                        <option key={id} value={id}>
                                            {title}
                                        </option>
                                    ))}
                                </Field>
                            </label>
                            <label className="tw-flex tw-flex-col">
                                <div className="select-label">{$t('Priority')}:</div>
                                <Field as="select" className="select-input" name="priority">
                                    <option value="">{$t('Priority')}</option>
                                    {PRIORITIES.map((priority) => (
                                        <option key={priority} value={priority}>
                                            {priority}
                                        </option>
                                    ))}
                                </Field>
                            </label>
                            {props.showSourceFilter && (
                                <VenueSelector
                                    label={$t('Source')}
                                    venuesOptions={sourceOptions}
                                    values={values}
                                    valueKey="source_ids"
                                    onChange={(venues) => {
                                        setFieldValue('source_ids', venues?.map((venue) => venue.value) || []);
                                    }}
                                    disabled={isSubmitting}
                                />
                            )}
                            <DepartmentSelector
                                label={$t('Departments')}
                                departmentsOptions={props.datasets.departmentsOptions}
                                disabled={props.budget_department_type && props.budget_department_id}
                                values={values}
                                onChange={(department) => {
                                    setFieldValue('budget_department_key', department.value);
                                }}
                            />
                        </div>
                        <div className="tw-flex tw-justify-end tw-gap-x-2 tw-pt-3">
                            <button className="table__filter-modal__apply-btn !tw-bg-red" type="button" onClick={handleReset}>
                                {$t('Reset all')}
                            </button>
                            <button className="table__filter-modal__apply-btn" type="button" onClick={handleSubmit}>
                                {$t('Apply filters')}
                            </button>
                        </div>
                    </div>
                )}
            </Formik>
        </TableFilterModal>
    );
}
